module.exports = __webpack_public_path__ + "media/promo/courses/images/footer1-552af9d847979ddcde2e9d58015a1939.png";